import cancellationPolicyActions from '../actions/cancellationPolicyActions';
import carouselActions from '../actions/carouselActions';
import chatbotActions from '../actions/chatbotActions';
import vtHelpfulnessActions from '../actions/vtHelpfulnessActions';
import contactOwnerFormActions from '../actions/contactOwnerFormActions';
import datePickerActions from '../actions/datePickerActions';
import edapActions from '../actions/edapActions';
import guestSelectorActions from '../actions/guestSelectorActions';
import inquiryModalActions from '../actions/inquiryModalActions';
import listingActions from '../actions/listingActions';
import listingPageActions from '../actions/listingPageActions';
import navigationActions from '../actions/navigationActions';
import requestToBookModalActions from '../actions/requestToBookModalActions';
import reviewsActions from '../actions/reviewsActions';
import routerActions from '../actions/routerActions';
import travelerActions from '../actions/travelerActions';
import tripActions from '../actions/tripActions';
import windowActions from '../actions/windowActions';
import {registerMiddleware} from '@homeaway/redux-middleware-adapter';
import {logToServer} from './logger';
import {logPrimaryActionRendered} from './utils/logPrimaryActionRendered';
import {selectNextImage, selectPrevImage} from './carousel';
import {requestToBookModalSubmit} from './requestToBookModal';
import {
    fetchReviewsSuccess,
    viewAllReviews,
    translateReviews,
    showOriginalReviews
} from './reviews';
import {inquirySubmit, inquiryModalRequestToBook, inquiryPostApplink} from './inquiryModal';
import {chatbotRequestToBook, triggerChatExitToast} from './chatbot';
import fetchListingCancellationPolicy from './listingCancellationPolicy';
// Temporary fix for the issue in HAVAS-700
// import updateDamagePolicyIfDatesSelected from './damagePolicy';
import {
    triggerEdapEvent,
    triggerEdapListingBooknowClick,
    triggerEdapCheckoutSelected,
    triggerEdapPropertySummaryPresented,
    triggerEdapPropertyDetailsMapPresented,
    triggerEdapPropertyDetailsPartnerInformationDetailsSelected,
    triggerEdapPropertyDetailsAmenitiesDetailsSelected,
    uxPropertyDetailsNavigationSelected,
    triggerEdapPropertyDetailsDescriptionPresented,
    triggerEdapPropertyInquirySelected,
    triggerEdapPropertyDetailsReviewsDetailsSelected,
    triggerEdapPropertyDetailsReviewsPresented,
    triggerEdapPropertyDetailsAmenitiesPresented,
    triggerEdapPropertyDetailsHouseRulesPresented,
    triggerEdapPropertyDetailsDescriptionDetailsSelected,
    triggerEdapPropertyDetailsPolicyCancellationPresented,
    logTestExposure
} from './edap';
import {tripDetailsChanged, tripDetailsEdapCheck} from './trip';
import {
    closeDatePickerModal,
    openDatePickerModal,
    selectedDatesSubmit,
    changedSelectedDates
} from './datePicker';
import {
    guestSelectorChanged,
    openGuestSelectorModal,
    closeGuestSelectorModal,
    submitGuestSelectorModal
} from './guestSelector';
import {
    civilCodeDisclaimerClicked,
    setCivilCodeDisclaimerModalOpen,
    setRequestToBookModalOpen,
    setInquiryModalOpen,
    setImageCarouselModalOpen,
    setVirtualTourModalOpen,
    setDescriptionModalOpen,
    setUnitDescriptionModalOpen,
    setGeneratedDescriptionModalOpen,
    setAmenityModalOpen,
    setCancellationTimelineModalOpen,
    setOwnerProfileModalOpen,
    pageLoadedFetchRegistrationNumber,
    pageLoadedFetchGeoDistance,
    processServerSideEvaluatedTests,
    triggerUrgencyToast,
    updateTripDataCookie,
    setLocationModalOpen,
    setMapModalOpen,
    setReviewsModalOpen,
    setSearchModalOpen,
    setSearchDatePickerModalOpen,
    setSearchGuestPickerModalOpen,
    viewPriceDetailsClicked,
    inquiryClicked,
    navClicked,
    logPriceSummaryEvent,
    fetchPropertyDescriptionLocalized,
    setVerticalGalleryModalOpen,
    setToiModalOpen,
    triggerVTExitToast
} from './listingPage';
import {fetchUserData, fetchUserDataAndSetLoggedIn} from './userData';
import {setActiveNavTab} from './navigation';
import {
    registerStickyPosition,
    windowSizeChanged,
    windowScrolled,
    reloadPage
} from './windowHandler';
import {contactOwnerFormFieldEdited, contactOwnerFormFieldTouched} from './contactOwnerForm';
import {syncModalStateWithRoute, navigate, updateUrlAfterModalChange} from './router';
import primaryCTAClicked from './primaryCta';

import {registerTripBoardsMiddleware} from '@homeaway/react-trip-board-button';

// List out all middleware functions and the action that they respond to
function registerAllMiddleware() {
    registerMiddleware(routerActions.LOCATION_CHANGE, syncModalStateWithRoute);
    registerMiddleware(routerActions.NAVIGATE, navigate);

    registerMiddleware(carouselActions.SELECT_NEXT, selectNextImage);
    registerMiddleware(carouselActions.SELECT_PREV, selectPrevImage);

    registerMiddleware(chatbotActions.REQUEST_TO_BOOK, chatbotRequestToBook);
    registerMiddleware(chatbotActions.TRIGGER_CHAT_EXIT_TOAST, triggerChatExitToast);

    registerMiddleware(vtHelpfulnessActions.TRIGGER_VT_EXIT_TOAST, triggerVTExitToast);

    registerMiddleware(listingActions.LOG_TO_SERVER, logToServer);
    registerMiddleware(listingActions.PAGE_LOADED, pageLoadedFetchRegistrationNumber);
    registerMiddleware(listingActions.PAGE_LOADED, pageLoadedFetchGeoDistance);
    registerMiddleware(listingActions.PAGE_LOADED, fetchUserDataAndSetLoggedIn);

    registerMiddleware(listingPageActions.PRIMARY_ACTION_RENDERED, logPrimaryActionRendered);

    registerMiddleware(listingActions.SET_TRIP_COOKIE, updateTripDataCookie);
    registerMiddleware(listingActions.PRIMARY_CTA_ACTIVATED, primaryCTAClicked);

    registerMiddleware(windowActions.SET_STICKY_POSITION, registerStickyPosition);
    registerMiddleware(windowActions.WINDOW_SIZE_CHANGED, windowSizeChanged);
    registerMiddleware(windowActions.WINDOW_SCROLLED, windowScrolled);
    registerMiddleware(windowActions.WINDOW_RELOAD, reloadPage);

    registerMiddleware(reviewsActions.VIEW_ALL_REVIEWS, viewAllReviews);
    registerMiddleware(reviewsActions.FETCH_REVIEWS_SUCCESS, fetchReviewsSuccess);

    registerMiddleware(reviewsActions.TRANSLATE_REVIEWS, translateReviews);
    registerMiddleware(reviewsActions.SHOW_ORIGINAL_REVIEWS, showOriginalReviews);

    registerMiddleware(edapActions.TRIGGER_EDAP_EVENT, triggerEdapEvent);
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_INQUIRY_SELECTED,
        triggerEdapPropertyInquirySelected
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_DETAILS_SELECTED,
        triggerEdapPropertyDetailsReviewsDetailsSelected
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_LISTING_BOOKNOW_CLICK,
        triggerEdapListingBooknowClick
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_PRESENTED,
        triggerEdapPropertyDetailsReviewsPresented
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_PARTNER_INFORMATION_SELECTED,
        triggerEdapPropertyDetailsPartnerInformationDetailsSelected
    );
    registerMiddleware(edapActions.TRIGGER_EDAP_CHECKOUT_SELECTED, triggerEdapCheckoutSelected);
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_PRESENTED,
        triggerEdapPropertyDetailsDescriptionPresented
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_DETAILS_SELECTED,
        triggerEdapPropertyDetailsDescriptionDetailsSelected
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_SUMMARY_PRESENTED,
        triggerEdapPropertySummaryPresented
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_UX_PROPERTY_DETAILS_NAVIGATION_SELECTED,
        uxPropertyDetailsNavigationSelected
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_POLICY_CANCELLATION_PRESENTED,
        triggerEdapPropertyDetailsPolicyCancellationPresented
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_DETAILS_SELECTED,
        triggerEdapPropertyDetailsAmenitiesDetailsSelected
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_PRESENTED,
        triggerEdapPropertyDetailsAmenitiesPresented
    );
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_HOUSE_RULES_PRESENTED,
        triggerEdapPropertyDetailsHouseRulesPresented
    );
    registerMiddleware(edapActions.LOG_TEST_EXPOSURE, logTestExposure);
    registerMiddleware(
        edapActions.TRIGGER_EDAP_PROPERTY_DETAILS_MAP_PRESENTED,
        triggerEdapPropertyDetailsMapPresented
    );
    registerMiddleware(datePickerActions.SUBMIT_SELECTED_DATES, selectedDatesSubmit);
    registerMiddleware(datePickerActions.CHANGED_SELECTED_DATES, changedSelectedDates);

    registerMiddleware(guestSelectorActions.GUEST_SELECTOR_CHANGED, guestSelectorChanged);
    registerMiddleware(guestSelectorActions.SUBMIT_GUEST_SELECTOR, submitGuestSelectorModal);

    registerMiddleware(tripActions.TRIP_DETAILS_CHANGED, tripDetailsChanged);
    registerMiddleware(
        cancellationPolicyActions.GET_LISTING_CANCELLATION_POLICY,
        fetchListingCancellationPolicy
    );
    // Temporary fix for the issue in HAVAS-700
    // registerMiddleware(tripActions.TRIP_DETAILS_CHANGED, updateDamagePolicyIfDatesSelected);
    registerMiddleware(listingActions.OPEN_DATE_PICKER_MODAL, openDatePickerModal);
    registerMiddleware(listingActions.CLOSE_DATE_PICKER_MODAL, closeDatePickerModal);
    registerMiddleware(listingActions.OPEN_GUEST_SELECTOR_MODAL, openGuestSelectorModal);
    registerMiddleware(listingActions.CLOSE_GUEST_SELECTOR_MODAL, closeGuestSelectorModal);
    registerMiddleware(listingActions.REQUEST_TO_BOOK_MODAL_OPEN, setRequestToBookModalOpen);
    registerMiddleware(listingActions.INQUIRY_MODAL_OPEN, setInquiryModalOpen);
    registerMiddleware(
        listingActions.CIVIL_CODE_DISCLAIMER_MODAL_OPEN,
        setCivilCodeDisclaimerModalOpen
    );
    registerMiddleware(listingActions.DESCRIPTION_MODAL_OPEN, setDescriptionModalOpen);
    registerMiddleware(listingActions.UNIT_DESCRIPTION_MODAL_OPEN, setUnitDescriptionModalOpen);
    registerMiddleware(
        listingActions.GENERATED_DESCRIPTION_MODAL_OPEN,
        setGeneratedDescriptionModalOpen
    );
    registerMiddleware(listingActions.AMENITY_MODAL_OPEN, setAmenityModalOpen);
    registerMiddleware(listingActions.OWNER_PROFILE_MODAL_OPEN, setOwnerProfileModalOpen);
    registerMiddleware(listingActions.LOCATION_MODAL_OPEN, setLocationModalOpen);
    registerMiddleware(listingActions.MAP_MODAL_OPEN, setMapModalOpen);
    registerMiddleware(listingActions.REVIEWS_MODAL_OPEN, setReviewsModalOpen);
    registerMiddleware(listingActions.SEARCH_MODAL_OPEN, setSearchModalOpen);
    registerMiddleware(
        listingActions.SEARCH_GUEST_PICKER_MODAL_OPEN,
        setSearchGuestPickerModalOpen
    );
    registerMiddleware(
        listingActions.CANCELLATION_TIMELINE_MODAL_OPEN,
        setCancellationTimelineModalOpen
    );
    registerMiddleware(listingActions.SEARCH_DATE_PICKER_MODAL_OPEN, setSearchDatePickerModalOpen);
    registerMiddleware(listingActions.VIRTUAL_TOUR_MODAL_OPEN, setVirtualTourModalOpen);
    registerMiddleware(listingActions.VERTICAL_GALLERY_MODAL_OPEN, setVerticalGalleryModalOpen);
    registerMiddleware(listingActions.IMAGE_CAROUSEL_MODAL_OPEN, setImageCarouselModalOpen);
    registerMiddleware(listingActions.TOI_MODAL_OPEN, setToiModalOpen);
    registerMiddleware(listingActions.UPDATE_MODAL_STATE, updateUrlAfterModalChange, 'after');

    registerMiddleware(
        contactOwnerFormActions.CONTACT_OWNER_FORM_FIELD_EDITED,
        contactOwnerFormFieldEdited
    );
    registerMiddleware(
        contactOwnerFormActions.CONTACT_OWNER_FORM_FIELD_TOUCHED,
        contactOwnerFormFieldTouched
    );
    registerMiddleware(inquiryModalActions.INQUIRY_SUBMIT, inquirySubmit);
    registerMiddleware(inquiryModalActions.REQUEST_TO_BOOK, inquiryModalRequestToBook);
    registerMiddleware(requestToBookModalActions.BOOKING_SUBMIT, requestToBookModalSubmit);

    registerMiddleware(tripActions.TRIP_DETAILS_EDAP_CHECK, tripDetailsEdapCheck);

    registerMiddleware(listingPageActions.TRIGGER_URGENCY_TOAST, triggerUrgencyToast);
    registerMiddleware(listingPageActions.VIEW_PRICE_DETAILS_CLICKED, viewPriceDetailsClicked);
    registerMiddleware(listingPageActions.INQUIRY_CLICKED, inquiryClicked);
    registerMiddleware(navigationActions.NAV_CLICKED, navClicked);
    registerMiddleware(
        listingPageActions.CIVIL_CODE_DISCLAIMER_CLICKED,
        civilCodeDisclaimerClicked
    );
    registerMiddleware(
        listingPageActions.PROCESS_SERVER_SIDE_EVALUATED_TESTS,
        processServerSideEvaluatedTests
    );
    registerMiddleware(navigationActions.DETERMINE_ACTIVE_NAV_TAB, setActiveNavTab);

    registerMiddleware(listingPageActions.LOG_PRICE_SUMMARY_EVENT, logPriceSummaryEvent);

    registerMiddleware(travelerActions.USER_LOGGED_IN, fetchUserData);
    registerMiddleware(
        listingPageActions.TRANSLATE_PROPERTY_DESCRIPTION,
        fetchPropertyDescriptionLocalized
    );

    registerTripBoardsMiddleware(registerMiddleware);

    registerMiddleware(inquiryModalActions.INQUIRY_APPLINK_UPDATE, inquiryPostApplink);
}

export default registerAllMiddleware;
